/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './structured-list';
import './structured-list-head';
import './structured-list-header-row';
import './structured-list-header-cell';
import './structured-list-body';
import './structured-list-group';
import './structured-list-row';
import './structured-list-cell';
import '@carbon/web-components/es/components/tooltip/index.js';
import '@carbon/web-components/es/components/tag/index.js';
